import HealthService from '@utility/services/health';
import { useEffect, useState } from 'react';

/* Waits before each retry. One failed GET /health (a network blip, a WAF
   challenge, a timeout) must not put the maintenance page in front of
   customers, so ApiNotActive shows only after every attempt has failed. */
export const HEALTH_RETRY_DELAYS_MS = [500, 1000, 2000];

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const useHealth = () => {
  const [isApiStatusOK, setIsApiStatusOK] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      for (let attempt = 0; ; attempt++) {
        try {
          await HealthService.checkHealth();
          if (!cancelled) setIsApiStatusOK(true);
          return;
        } catch {
          if (attempt >= HEALTH_RETRY_DELAYS_MS.length) {
            if (!cancelled) setIsApiStatusOK(false);
            return;
          }
        }
        await wait(HEALTH_RETRY_DELAYS_MS[attempt]);
        if (cancelled) return;
      }
    };
    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  return { isApiStatusOK };
};
